import { combineReducers } from "redux";
import { Cooperation } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { FETCH_CO_OPERATIONS_REQUEST } from "./constants";
import { Action } from "./types";

function items(state: Cooperation[] = [], action: Action): Cooperation[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_CO_OPERATIONS_REQUEST):
      return action.payload;

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_CO_OPERATIONS_REQUEST:
      return true;
    case getSuccessActionType(FETCH_CO_OPERATIONS_REQUEST):
    case getFailureActionType(FETCH_CO_OPERATIONS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const cooperations = combineReducers({ items, isFetching });
